import { useTranslation } from "react-i18next";
import type { AnchorImpact, ImpactReport } from "./impactApi";
import StatusMessage from "../../ui/feedback/StatusMessage";

export default function ImpactReportView({ report }: { report: ImpactReport }) {
  const { t } = useTranslation();
  const results = report.findings.filter((finding) => finding.module === "data" && finding.kind === "result");
  const count = (impact: AnchorImpact) => results.filter((finding) => finding.impact === impact).length;
  return <div className="space-y-2 text-sm">
    <p>{t("importProposals.impact.summary", { documents: t("importProposals.impact.documentsChanged", { count: report.documentsChanged }), changed: count("changed"), unchanged: count("unchanged"), moved: count("moved"), removed: count("removed") })}</p>
    {results.length === 0 ? <StatusMessage tone="warning" className="p-2">{t("importProposals.impact.absent")}</StatusMessage> : null}
    {report.findings.length > 0 ? <details>
      <summary className="cursor-pointer">{t("importProposals.impact.findings", { count: report.findings.length })}</summary>
      <ul className="max-h-96 space-y-2 overflow-auto py-2">
        {report.findings.map((finding) => <li key={`${finding.module}:${finding.kind}:${finding.identifier}`} className="app-card space-y-1 p-2">
          <p>{finding.module} / {finding.kind}: <span className="font-mono text-xs break-all">{finding.identifier}</span></p>
          <p>{t(`importProposals.impact.outcomes.${finding.impact}`)}{finding.decision === null ? "" : ` · ${t(`importProposals.impact.decisions.${finding.decision}`)}`}</p>
          {!finding.bulkCarryForwardEligible && finding.decision === null ? <p>{t("importProposals.impact.needsAttention")}</p> : null}
          <p className="app-text-muted break-all font-mono text-xs">{finding.anchor}</p>
          {finding.quote === null ? null : <blockquote>{finding.quote}</blockquote>}
        </li>)}
      </ul>
    </details> : null}
  </div>;
}
